// 修改导入语句
import { showWebview,closeWebview,qrCodeResult,openQRCodeScan,webOpenUrl ,copyText , statusBarParams, getNativeInfo} from "@/service/jsbridge.js"
import ArmsRum from '@arms/rum-browser';

export const errorMap = {
	500: "服务器错误",
	602: "用户名或密码不合法",
	610: "用户名格式错误",
	612: "用户已存在",
	620: "用户不存在",
	621: "密码错误",
};

export function jsonParse(str, defaultObject = []) {
	try {
		const data = str && "object" === str ? str : JSON.parse(str);
		return data;
	} catch (e) {
		console.error(e);
		return defaultObject;
	}
}

/**
 * 获取页面参数
 */
export function getPageQuery() {
	const curPages = getCurrentPages();
	// 处理无页面栈的情况
	if (curPages.length === 0) {
	  return {};
	}
	const { uniPlatform: platform } = uni.getSystemInfoSync();
	const isWebOrH5 = platform === 'web' || platform === 'h5';
	const lastPage = curPages[curPages.length - 1];
	const curPage = isWebOrH5 ? lastPage?.$page : lastPage;
	// 安全访问options属性
	return curPage?.options || {};
  }
/**
 * js获取扫码参数
 */
export function getQueryParams(fullUrl) {
// 提取哈希片段
const hashIndex = fullUrl.indexOf('#');
const hashFragment = hashIndex !== -1 ? fullUrl.substring(hashIndex + 1) : '';

// 提取哈希片段中的查询参数
const queryIndex = hashFragment.indexOf('?');
const queryString = queryIndex !== -1 ? hashFragment.substring(queryIndex + 1) : '';

// 使用URLSearchParams解析查询参数
const params = new URLSearchParams(queryString);

// 获取参数值
const scanToData = params.get('scanToData'); // '{"fromUser":10791,"group":"hb_dev@group_s16pDa6eF09PfBvp","type":"group"}'
const TIMLogin = params.get('TIMLogin');     // "0"

// 如果需要解析JSON字符串
const scanToDataObj = scanToData ? JSON.parse(scanToData) : null;
return scanToDataObj
}
/**
 * 解析url参数
 */
export function resolveUrlParameters(fullUrl) {
	// 提取哈希片段
	const hashIndex = fullUrl.indexOf('#');
	const hashFragment = hashIndex !== -1 ? fullUrl.substring(hashIndex + 1) : '';
	
	// 提取哈希片段中的查询参数
	const queryIndex = hashFragment.indexOf('?');
	const queryString = queryIndex !== -1 ? hashFragment.substring(queryIndex + 1) : '';
	console.log(queryString)
	// 使用URLSearchParams解析查询参数
	const params = new URLSearchParams(queryString);
	console.log(params)
	return params
}

/**
 * 返回上一页
 */
export function customConduct(){
	let curPage = getCurrentPages();
	if(curPage.length > 1){
		uni.navigateBack({
			delta:1
		})
	}else{
		closeWebview()
	}
}
/**
 * 判断是否在微信内打开
 */
export function isInWeChat() {
	var userAgent = navigator.userAgent.toLowerCase();
	return userAgent.indexOf('micromessenger')!== -1;
}
/**
 * 获取移动端操作系统
 */
export function getMobileOperatingSystem() {
	var userAgent = navigator.userAgent || navigator.vendor || window.opera;

	// 安卓系统
	if (/android/i.test(userAgent)) {
		return 'Android';
	}

	// iOS 系统
	if (/iPad|iPhone|iPod/.test(userAgent) &&!window.MSStream) {
		return 'iOS';
	}
	// 其他系统
	return 'Other';
}


/**
 * 保存图片
 * @param canvasElement 目标canvas
 * @param fileName 文件名
 */
export function base64ToPng(base64, fileName) {
  const MIME_TYPE = "image/png";
	const arr = base64.split(',');
	const bytes = atob(arr[1]);
	const ab = new ArrayBuffer(bytes.length);
	const ia = new Uint8Array(ab);
	for (let i = 0; i < bytes.length; i++) {
		ia[i] = bytes.charCodeAt(i);
	}
	const blob = new Blob([ab], { type: 'application/octet-stream' });
	const url = URL.createObjectURL(blob);
	const dlLink = document.createElement('a');
	dlLink.download = `${fileName}.png`;
	dlLink.href = url;
	dlLink.dataset.downloadurl = [MIME_TYPE, dlLink.download, dlLink.href].join(':');
	document.body.appendChild(dlLink);
	dlLink.click();
	document.body.removeChild(dlLink);
}
/**
 * 判断双击还是单击
 * 单击：fn1
 * 双击：fn2
 */
let clickTimeout= null;
let clickDelay = 300; // 单击和双击之间的时间间隔，单位为毫秒
export function handleClick(fn1=null, fn2=null) {
	if (clickTimeout) {
		// 如果定时器存在，说明这是双击
		clearTimeout(clickTimeout);
		clickTimeout = null;
		fn2 && fn2();
	} else {
		// 如果定时器不存在，说明这是第一次点击
		clickTimeout = setTimeout(() => {
			fn1 && fn1();
			clickTimeout = null;
		}, clickDelay);
	}
}

/**
 * 扫码跳转到指定页面
 * 如果app未安装，则跳转到下载页，如果app已安装，则跳转到指定url
 */
export function scanToPage() {
	let url = "";
	let pageUrl = "/fiveteachersH5/#/pagesH5/download/index";
	let testUrl = "/fiveteachersH5/test/#/pagesH5/download/index";
	if(process.env.VUE_APP_TRACK_ENV=='test'){
		url= "https://m.laikang.com/qa" + testUrl
	}else{
		url= "https://m.laikang.com/"+ process.env.VUE_APP_TRACK_ENV + pageUrl
	}
	return url;
}
/**
 * 是否在app内
 */
export function isInApp() {
	const userAgent = navigator.userAgent || navigator.vendor;
	return  userAgent.indexOf('lKZbApp') > -1;
}
/**
 * 返回当前环境的项目域名
 */
export function getDomain() {
	let url = "";
	let pageUrl = "/fiveteachersH5/#";
	let testUrl = "/fiveteachersH5/test/#";
	if(process.env.VUE_APP_TRACK_ENV=='test'){
		url= "https://m.laikang.com/qa" + testUrl
	}else{
		url= "https://m.laikang.com/"+ process.env.VUE_APP_TRACK_ENV + pageUrl
	}
	return url;
}
/**
 * app扫码
 * {"data":{"examid":"31166695"},"type":"facialTongueExamReport"}
 */
export function scanTheCode() {
	openQRCodeScan()
	qrCodeResult((data) => {
		// 格式 https://m.laikang.com/qa/content-dissemination-platform/zxbMini?reportId=1&type=FACE_TONGUE&deviceId=1
		console.log('接受的原始数据', data)
		const scanStr = data.trim()
		let obj = { data: {examid: '', deviceId: ''}, type: ''} //给的默认结构
		// 如果是链接开头的 就解析参数
		if (scanStr.startsWith('http://') || scanStr.startsWith('https://')) {
			const urlObj = new URL(scanStr)
			// 如果参数在 hash 中需要再解析
			let search = urlObj.search
			if (!search && urlObj.hash.includes('?')) {
				search = urlObj.hash.substring(urlObj.hash.indexOf('?'))
			}
			const params = new URLSearchParams(search)
			obj=  {
				data: {
					examid: params.get('examid') || '',
					deviceId: params.get('deviceId') || '',
				},
				type: params.get('type') || 'facialTongueExamReport'
			}
		} else { // 否则就返回一个字符串json 格式为 {data: {examid: 'xx'}, type: 'facialTongueExamReport'}
			obj = JSON.parse(scanStr)
		}
		console.log('app扫码==',obj)
		// 共用的面舍诊页面 一般的面设镇都走这里 
		const path = "fromType=qrCode&examId="+obj.data.examid+"&type="+obj.type+"&deviceId="+obj.data.deviceId
		console.log('跳转的页面query参数', path)
		let finallyUrl = '/pagesH5/userSettings'
		if(obj.type=='facialTongueExamReport'){
			finallyUrl += "/facialAndTongueDiagnosis?"+path;
		}
		// 特殊的面舍诊页面
		// 太阳宫 max镜子扫码领走报告面舍诊 FACE_TONGUE 走单独的报告页面  2026/06/03 太阳宫 max镜子扫码领走 体质辨识报告
		if(obj.type=='FACE_TONGUE' || obj.type== "CONSTITUTION"){
			finallyUrl += "/facialAndTongueDiagnosisTwo?"+path;
		}
		// 公共的路径前缀
		let domainName = "https://m.laikang.com/"+process.env.VUE_APP_TRACK_ENV+"/fiveteachersH5/#"
		if(process.env.VUE_APP_TRACK_ENV=="test")domainName = "https://m.laikang.com/qa/fiveteachersH5/test/#"
		console.log('最终的跳转地址', domainName + finallyUrl)
		webOpenUrl(domainName + finallyUrl)
	})
}

/**
 * 复制文本到剪贴板
 */
export function copyToClipboard(text) {
	copyText(text)
  }

/**
 * ArmsRUM上报自定义数据
 * @param type 自定义类型 必选
 * @param name 自定义名称 必选
 * @param value(number) 自定义数值 可选
 * @param properties(object) 自定义属性 可选
 */
export function armsRumCustom(type, name, value = 0, properties = {}) {
	console.log('armsRumCustom==',type, name, value, properties)
	ArmsRum.sendCustom({	
		type,
		name,
		group: uni.getStorageSync("TIMGroupID"),
		value,
		properties,
	});
}
/**
 * 比较版本号
 * @param version1 版本号1
 * @param version2 版本号2
 * @returns 1：version1 > version2
 *          0：version1 = version2
 *         -1：version1 < version2
 */	
export function compareVersions(version1, version2) {
	const v1Parts = version1.split('.').map(Number);
	const v2Parts = version2.split('.').map(Number);
	
	const maxLength = Math.max(v1Parts.length, v2Parts.length);
	
	for (let i = 0; i < maxLength; i++) {
		const num1 = i < v1Parts.length ? v1Parts[i] : 0;
		const num2 = i < v2Parts.length ? v2Parts[i] : 0;
		
		if (num1 > num2) return 1;
		if (num1 < num2) return -1;
	}
	
	return 0;
}
/**
 * 获取状态栏高度
 * @returns {Promise<string>} 返回带单位的高度字符串
 */
export async function getStatusBarHeight() {
    const { platform, statusBarHeight } = uni.getSystemInfoSync();
    let base = statusBarHeight + 4; // iOS 24px
    // App环境下使用JSBridge或URL参数获取更精准的胶囊高度
    if (isInApp()) {
        const query = getPageQuery() || {};
        if (platform.toLowerCase() === "ios" && query.app_version && compareVersions(query.app_version, "1.3.0") >= 0 && query.statusBarShow) {
            return query.GK_NAVBAR_HEIGHT + "px";
        }
        const res = await statusBarParams();
        return res.show ? `${base + 38}px` : `${res.height}px`;
    }
    // H5或小程序直接使用经验值
    return `${base + 38}px`;
}
/**
删除健康指标的数据，需要根据type来获取对应的数据
itemCodes：删除的指标code
url:编辑回显的页面地址
ID：删除的ID
*/
export function getCode(type) {
	switch (type) {
		case "1":
			return {
				itemCodes: ["010001", "010002", "XYZBXY001001"],
				url: "/pagesMonitor/monitor/add-weight",
				id: "102",
			};
		case "2":
			return {
				itemCodes: [
					"lk1589863366702",
					"lk1646721531103",
					"lk1686881563833",
				],
				url: "/pagesMonitor/monitor/add-waist",
				id: "103",
			};
		case "3":
			return {
				itemCodes: ["020020_sbp", "020020_dbp", "020022"],
				url: "/pagesMonitor/monitor/add-blood-pressure",
				id: "105",
			};
		case "4":
			return {
				itemCodes: [
					"06EX",
					"06CV",
					"06DJ",
					"07AA",
					"06LW",
					"07AB",
					"06DP",
					"07AC",
					"07AD",
					"07AE",
					"07AF",
					"07AG",
					"07AH",
					"07AI",
					"07AJ",
					"07AK",
					"07AL",
					"53FG",
				],
				url: "/pagesMonitor/monitor/add-blood-sugar",
				id: "104",
			};
		case "5":
			return {
				itemCodes: [],
				url: "/pagesMonitor/monitor/add-drug",
				id: "101",
			};
		case "6":
			return {
				itemCodes: ["53FG"],
				url: "/pagesMonitor/monitor/add-blood-sugar",
				id: "104",
			};
		case "7":
			return {
				itemCodes: ["XYZBQT10_DESC_TRANSED"],
				url: "/pagesH5/hardware/resultPressure",
				id: "107",
			};
		case "8":
			return {
				itemCodes: ["010002", "XYZBXY001001", "XYZBXY0010240", "XYZBXY0010241"],
				url: "/pagesMonitor/monitor/add-weight",
				id: "102",
			};
		default:
			break;
	}
}

/**
 * 检查 app 版本号并判断是否使用新方法
 * @param {Array<{platform: string, version: string}>} versionConfig - 版本配置数组
 *   例如: [{ platform: 'Android', version: '1.17.0' }, { platform: 'iOS', version: '1.4.4' }]
 *   如果不传参数，默认使用 Android: 1.17.0, iOS: 1.4.4
 * @returns {Promise<{useNewMethod: boolean, appVersion: string, platformType: string}>}
 */
export async function checkAppVersion(versionConfig = [
    { platform: 'Android', version: '1.17.0' },
    { platform: 'iOS', version: '1.4.4' }
]) {
    try {
        const res = await getNativeInfo()
        const appVersion = res.app_version || ''
        const platformType = getMobileOperatingSystem()
        
        console.log('获取到的app版本号:', appVersion)
        console.log('当前平台:', platformType)
        
        let useNewMethod = false
        
        // 根据配置判断是否使用新方法
        if (appVersion && versionConfig && versionConfig.length > 0) {
            const config = versionConfig.find(item => item.platform === platformType)
            if (config && config.version) {
                useNewMethod = compareVersions(appVersion, config.version) >= 0
                console.log(`${platformType} 版本阈值: ${config.version}`)
            }
        }
        
        console.log(useNewMethod ? '使用新版本方法' : '使用老版本方法')
        
        return {
            useNewMethod,
            appVersion,
            platformType
        }
    } catch (error) {
        console.error('获取app版本失败:', error)
        return {
            useNewMethod: false,
            appVersion: '',
            platformType: ''
        }
    }
}